// Map of scanned badge IDs to the dealer ID stored in our attendees list.
// The printed badges don't match our attendee records for these dealers,
// so when a listed badge is scanned we swap it to the matching attendee ID.
// Badges not present here are correct and should be used as-is.
export const dealerIdSwap: Record<string, string> = {
  "26000007": "26000009", // Adam Acosta
  "26000008": "26000007", // Carlos Acosta
  "26000009": "26000008", // Juan Acosta
  "26000022": "26000023", // Darrell Allen
  "26000023": "26000022", // Jason Allen
  "26000148": "26000149", // Amanda Chapman
  "26000149": "26000148", // Jerry Chapman
  "26000203": "26000204", // James Davies
  "26000204": "26000203", // Kirk Davies
  "26000205": "26000206", // Amanda Davis
  "26000206": "26000205", // Traci Davis
  "26000252": "26000253", // Jonathan Evans
  "26000253": "26000252", // Timothy Evans
  "26000267": "26000268", // Erin Fitzgerald
  "26000268": "26000267", // James Fitzgerald
  "26000271": "26000272", // Gabriel Flores
  "26000272": "26000271", // Jesse Flores
  "26000293": "26000294", // Jesse Garcia
  "26000294": "26000293", // Miguel Garcia
  "26000316": "26000317", // Geof Gibson
  "26000317": "26000318", // Michael Gibson
  "26000318": "26000319", // Pamela Gibson
  "26000319": "26000316", // Sean Gibson
  "26000324": "26000325", // Patty Gillissie
  "26000325": "26000324", // Patty Gillissie
  "26000352": "26000353", // Evan Grossman
  "26000353": "26000352", // Matthew Grossman
  "26000391": "26000392", // Manuel Hernandez
  "26000392": "26000391", // Robert Hernandez
  "26000407": "26000408", // Deanne Hofer
  "26000408": "26000407", // Jim Hofer
  "26000436": "26000437", // Jessica Jafari
  "26000437": "26000438", // Kevin Jafari
  "26000438": "26000436", // Mike Jafari
  "26000447": "26000448", // Delarriot Johnson
  "26000448": "26000449", // Eric Johnson
  "26000449": "26000447", // Heather Johnson
  "26000450": "26000451", // Stephanie Johnson
  "26000451": "26000450", // Thomas Johnson
  "26000476": "26000477", // Amanda King
  "26000477": "26000476", // Anthony King
  "26000478": "26000479", // Eastyn King
  "26000479": "26000478", // Eric King
  "26000524": "26000527", // Ashley Lopez
  "26000526": "26000528", // Ivan Lopez
  "26000527": "26000524", // Jeimy Lopez
  "26000528": "26000526", // Michael Lopez
  "26000546": "26000547", // Benjamin Martinez
  "26000547": "26000546", // Tanya Martinez
  "26000593": "26000594", // Joseph Miller
  "26000594": "26000593", // Lana Miller
  "26000626": "26000627", // Brian Nelson
  "26000627": "26000626", // Mark Nelson
  "26000628": "26000626", // Mark Nelson
  "26000630": "26000631", // Irma Newman
  "26000631": "26000630", // Jeffrey Newman
  "26000634": "26000635", // Tom Nguyen
  "26000635": "26000634", // Tuan Nguyen
  "26000651": "26000653", // Andres Orozco
  "26000652": "26000651", // Ignocio Orozco
  "26000653": "26000652", // Victor Orozco
  "26000676": "26000677", // Hank Patel
  "26000677": "26000676", // Kunal Patel
  "26000683": "26000685", // Adrian Perez
  "26000685": "26000683", // Eduardo Perez
  "26000690": "26000691", // Lance Platt
  "26000691": "26000690", // Robyn Platt
  "26000725": "26000726", // Carlos Reyes
  "26000726": "26000727", // Lyd Reyes
  "26000727": "26000725", // Michael Reyes
  "26000728": "26000729", // Greg Reynolds
  "26000729": "26000728", // Troy Reynolds
  "26000730": "26000731", // Carol Rice
  "26000731": "26000730", // Erik Rice
  "26000743": "26000745", // Anthony Rodriguez
  "26000745": "26000746", // Yenin Rodriguez
  "26000746": "26000743", // Yoanna Paola Rodriguez
  "26000760": "26000762", // Carlos Ruiz
  "26000761": "26000760", // Gabe Ruiz
  "26000762": "26000761", // Michelle Ruiz
  "26000772": "26000773", // Ian Samuelson
  "26000773": "26000772", // Shadd Samuelson
  "26000774": "26000775", // Ana Sanchez
  "26000775": "26000774", // Chad Sanchez
  "26000802": "26000804", // Ekta Shah
  "26000804": "26000802", // Vik Shah
  "26000822": "26000825", // Aaron Smith
  "26000823": "26000826", // Aubrey Smith
  "26000824": "26000827", // Rebecca Smith
  "26000825": "26000823", // Ron Smith
  "26000826": "26000822", // Shay Smith
  "26000827": "26000824", // Steven Smith
  "26000844": "26000845", // Brandi Stevens
  "26000845": "26000844", // Scotland Stevens
  "26000864": "26000866", // Jennifer Taylor
  "26000866": "26000864", // Scott Taylor
  "26000873": "26000874", // Marcus Thomas
  "26000874": "26000873", // Raymond Thomas
  "26000875": "26000877", // Jessie Thompson
  "26000876": "26000875", // Joe Thompson
  "26000877": "26000876", // Melanie Thompson
  "26000943": "26000944", // Courtney Wells
  "26000944": "26000943", // Loretta Wells
  "26000945": "26000946", // Sheri Wengert
  "26000946": "26000945", // Tim Wengert
  "26000956": "26000957", // Dominique Williams
  "26000957": "26000956", // Tricia Williams
};
